var _rect, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionACrossOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#272727",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.017 20.5H16.3807L20.3977 8.86364H23.5682L27.5795 20.5H24.9432L22.0284 11.5227H21.9375L19.017 20.5ZM18.8523 15.9261H25.0795V17.8466H18.8523V15.9261Z",
    fill: "#272727"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.976197,
    y1: 15.0003,
    x2: 42.9762,
    y2: 14.0003,
    stroke: "#272727",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionACrossOut);
export default __webpack_public_path__ + "static/media/OptionACrossOut.4fd1e04f227dd53101a141b34a8660e9.svg";
export { ForwardRef as ReactComponent };